// core components/views
import Profile from "views/Account/Profile.jsx";
import { ServiceNumberCoverageType, ServiceNumberCoverage } from "views/Visitor/ServiceNumberCoverage";
import Dashboard from "views/Visitor/Dashboard.jsx";
import { gisRoutes } from './routes';
import Contacts from "views/Visitor/Contacts.jsx";

import phrasebookLoad from "../i18n";
const phrasebook = phrasebookLoad()

/**
 * @path available paths on the account page(before authorisation)
 * @component main page that links to the path (available in views folder)
 * @routeType route type is to check whether the routes is coming from account or portal
 */
const visitorRoutes = [
  {
    path: gisRoutes.visitor.profile,
    component: Profile,
    routeType: "visitor",
    type: "icon",
    category: "profile",
    name: phrasebook.profile.profile,
  },
  {
    path: gisRoutes.visitor.contacts,
    component: Contacts,
    // restrictedFunction: portalFunctionalityConstants.support.support,
    // action: permissionTypeConst.LIST,
    routeType: "portal",
    // type: 'icon',
    category: "support",
    name: phrasebook.headerlinks.contacts,
  },
  {
    path: gisRoutes.visitor.service_number_coverage_id,
    navbarName: phrasebook.headerlinks.service_coverage,
    component: ServiceNumberCoverageType,
    routeType: 'visitor'
  },
  {
    path: gisRoutes.visitor.service_number_coverage,
    navbarName: phrasebook.headerlinks.service_coverage,
    component: ServiceNumberCoverage,
    routeType: 'visitor'
  },
  {
    path: gisRoutes.visitor.dashboard,
    navbarName: phrasebook.headerlinks.visitor,
    component: Dashboard,
    routeType: 'visitor'
  },


  { redirect: true, path: "/", to: gisRoutes.visitor.dashboard, navbarName: "visitor", routeType: 'visitor' }
];

export default visitorRoutes;
